import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import styled from "styled-components";

type DefaultFormContainerProps = {
  $noPadding?: boolean;
};

export const DefaultFormContainer = styled.form<DefaultFormContainerProps>`
  && {
    width: 100%;
    padding: ${({ $noPadding }) => ($noPadding ? "0" : "24px")};
  }
`;

export const DefaultFormTitleContainer = styled.div`
  && {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }
`;

export const DefaultFormBackButton = styled(Link)`
  && {
    width: 32px;
    height: 32px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    text-decoration: none;
    cursor: pointer;
  }

  &&::before {
    content: "←";
    color: #0b234c;
    font-size: 24px;
    line-height: 1;
  }

  &&:focus-visible {
    outline: 2px solid #0b234c;
    outline-offset: 2px;
  }
`;

export const DefaultFormTitle = styled(Typography)`
  && {
    margin: 0;

    font-family: Figtree, sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;

    color: #0b234c;
  }
`;